import { useSuperPageSearch } from "./useSuperPageSearch";
import { useContentPageSearch } from "./useContentPageSearch";
import { useSuperPageAssignmentSearch } from "./useSuperPageAssignmentSearch";
import { useSuperPageAssignmentsOverview } from "./useSuperPageAssignmentsOverview";
import { useClearCallToActionsCache } from "./useCallToActions";

interface ClearVideoPageCacheOptions {
  superPages?: boolean;
}

export const useClearVideoPageCache = () => {
  const { clearContentPagesSearchCache } = useContentPageSearch();
  const { clearSuperPagesSearchCache } = useSuperPageSearch();
  const { clearSuperPageAssignmentsSearchCache } = useSuperPageAssignmentSearch();
  const { clearSuperPageAssignmentsOverviewCache } = useSuperPageAssignmentsOverview();
  const clearCallToActionsCache = useClearCallToActionsCache();

  const clearVideoPageCache = (options: ClearVideoPageCacheOptions = { superPages: true }) => {
    clearContentPagesSearchCache();
    clearCallToActionsCache();
    if (options.superPages) {
      clearSuperPagesSearchCache();
      clearSuperPageAssignmentsSearchCache();
      clearSuperPageAssignmentsOverviewCache();
    }
  };

  return { clearVideoPageCache };
};
